import React from 'react';

export const CertificatePreviewStep = ({
  previewUrl = '',
  loading = false,
  error = '',
  mode = 'individual',
  selectedStudentLabel = '',
  recipientCount = 0,
  canConfirm = false,
  onConfirm,
}) => {
  const hasPreview = Boolean(previewUrl) && !loading;

  return (
    <section
      className="certificate-wizard-card certificate-preview-step"
      aria-labelledby="certificate-preview-step-title"
    >
      <div className="certificate-wizard-card-heading">
        <span aria-hidden="true">4</span>
        <div>
          <h2 id="certificate-preview-step-title">Revisión y publicación</h2>
          <p>Revisa la constancia representativa antes de publicarla.</p>
        </div>
      </div>

      {loading && (
        <p
          className="certificate-preview-state"
          role="status"
          aria-live="polite"
        >
          Generando vista previa...
        </p>
      )}

      {error && (
        <p className="certificate-wizard-status" role="alert">
          {error}
        </p>
      )}

      {hasPreview && (
        <>
          <div className="certificate-preview-summary">
            {mode === 'masiva' ? (
              <strong>Se generarán {recipientCount} constancias</strong>
            ) : (
              <>
                <p>
                  <strong>Alumno seleccionado:</strong>{' '}
                  <span>{selectedStudentLabel}</span>
                </p>
                <strong>Se generará 1 constancia</strong>
              </>
            )}
          </div>
          <iframe
            className="certificate-preview-frame"
            title="Vista previa de la constancia"
            src={previewUrl}
          />
          <p className="certificate-preview-qr-note" role="note">
            El QR de validación se agrega al PDF definitivo al confirmar la
            publicación.
          </p>
        </>
      )}

      <div className="certificate-wizard-actions">
        <button type="button" disabled={!canConfirm} onClick={onConfirm}>
          Confirmar y publicar
        </button>
      </div>
    </section>
  );
};
